<template>
    <div>
        <ListExameComum :data="data" />
        <ListExameAltoCusto :data="data" />
    </div>
</template>

<script>
// Components.
import ListExameAltoCusto from './components/alto-custo/List'
import ListExameComum from './components/comum/List'

export default {
    components: {
        ListExameAltoCusto,
        ListExameComum,
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>